import styles from "./Switch.module.css";

/**
 * An on/off control for a setting that takes effect immediately — the appointments
 * board's "5 mins appointments" and "Hide days off" are the shape this follows.
 *
 * A switch rather than a tick box because nothing here is submitted: the list redraws
 * as soon as it is flipped. A checkbox promises a form that will be saved.
 */
export const Switch = ({ id, checked, onChange, label, disabled = false }) => (
  <label className={styles.label} htmlFor={id}>
    <span className={styles.track}>
      <input
        id={id}
        type="checkbox"
        role="switch"
        className={styles.input}
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
      />
      <span className={styles.slider} />
    </span>
    {!!label && <span className={styles.text}>{label}</span>}
  </label>
);
